import { Stack, SvgIconTypeMap, SxProps, Theme } from '@mui/material'
import { OverridableComponent } from '@mui/material/OverridableComponent'

interface OutlinedIconProps {
  Icon: OverridableComponent<SvgIconTypeMap<unknown, 'svg'>> & {
    muiName: string
  }
  sx?: SxProps<Theme>
  color: SvgIconTypeMap['props']['color']
}

export const OutlinedIcon = (props: OutlinedIconProps) => {
  const { Icon, sx, color } = props

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={[styles.container, sx] as SxProps<Theme>}
    >
      <Stack alignItems="center" justifyContent="center" sx={styles.circle}>
        <Icon color={color} sx={styles.icon} />
      </Stack>
    </Stack>
  )
}

const styles = {
  container: {
    width: 120,
    height: 100,
    backgroundColor: 'brandGrey.base',
    borderRadius: 4
  },
  circle: {
    width: 80,
    height: 80,
    borderRadius: 40,
    backgroundColor: 'background.default'
  },
  icon: {
    width: 40,
    height: 40
  }
}
